import Swiper from "swiper";
import { Navigation } from "swiper/modules";

let swiperInstances = [];

// Mobile media query
const mobileQuery = window.matchMedia("(max-width: 791px)");

// Initialize or destroy swiper based on screen size
const handleScreenChange = (e) => {
  if (e.matches) {
    // Mobile view - initialize swiper
    initSwiper();
  } else {
    // Desktop view - destroy swiper
    destroySwiper();
  }
};

// Initialize swiper
const initSwiper = () => {
  // First destroy any existing instances
  destroySwiper();

  const containers = document.querySelectorAll(".guides-charts-carousel");

  containers.forEach((container) => {
    const carousel = container.querySelector(".swiper");
    const arrowPrev = container.querySelector(".swiper-button-prev");
    const arrowNext = container.querySelector(".swiper-button-next");
    const slidesCount = parseInt(container.dataset.slidesCount, 10) || 0;

    // Hide arrows if only one slide
    if (slidesCount <= 1) {
      arrowPrev.style.display = "none";
      arrowNext.style.display = "none";
    }

    // Create and store swiper instance
    const swiper = new Swiper(carousel, {
      modules: [Navigation],
      slidesPerView: 1,
      spaceBetween: 20,
      navigation: {
        nextEl: arrowNext,
        prevEl: arrowPrev
      }
    });

    swiperInstances.push(swiper);
  });
};

// Destroy all swiper instances
const destroySwiper = () => {
  swiperInstances.forEach(swiper => {
    if (swiper && typeof swiper.destroy === "function") {
      swiper.destroy(true, true);
    }
  });
  swiperInstances = [];
};

// Set up on DOM load
document.addEventListener("DOMContentLoaded", () => {
  // Initial check
  handleScreenChange(mobileQuery);

  // Listen for changes
  mobileQuery.addEventListener("change", handleScreenChange);
});
